import FormPage from '@/features/forms/pages/Form'

export default FormPage
